import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { getScreenshotAssets } from 'services/screenshot.service';
import { format, parseISO, parseJSON, toDate } from 'date-fns/esm';
import lodash from 'lodash';
import {
    AppBar,
    Tabs,
    Tab,
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Theme,
} from '@mui/material';
import { DataView } from 'primereact/dataview';
import '../../scss/screenshotDataView.scss';
import BaseErrorBoundry from 'views/Common/BaseErrorBoundry';
import theme from 'theme';
import { CssSelect } from 'views/Common/CssSelect';

const PREFIX = 'ScreenshotAssetViewByDate';

const classes = {
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        margin: theme.spacing(3),
        minWidth: 200,
    },

    [`& .${classes.selectEmpty}`]: {
        marginTop: theme.spacing(2),
    }
}));

interface ScreenshotAssetViewByDateProps {
	advertisementId: number;
	handleResult: any;
	campaignId: any;
}

function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
        <Root
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-auto-tabpanel-${index}`}
			aria-labelledby={`scrollable-auto-tab-${index}`}
			{...other}>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</Root>
    );
}
const ssAssets = new Map();
let keys: any = [];

export default function ScreenshotAssetViewByDate(props: ScreenshotAssetViewByDateProps) {

	const { advertisementId, campaignId } = props;
	const [list, setList] = useState([]);
	const [value, setValue] = useState(0);
	const [layout] = useState('grid');
	const [mainLocationName, setMainLocatioName] = React.useState('Select All');
	const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		console.warn('selected value', event.target.value);
		setMainLocatioName(event.target.value as string);
	};
	useEffect(() => {
		const getDetails = async () => {
			try {
				const screenshotDataService = await getScreenshotAssets({
					advertisementId: advertisementId,
					campaignId: campaignId,
				});
				if (screenshotDataService) {
					const values = screenshotDataService[0].screenshotAssets.map(
						(ele: any) => {
							const newObj = { ...ele };
							newObj.capturedTs = parseJSON(ele.capturedTs);
							newObj.capturedTsWithTime = format(
								newObj.capturedTs,
								'p',
							);

							newObj.capturedTs = format(newObj.capturedTs, 'yyyy-MM-dd');
							return newObj;
						},
					);
					keys = [];
					ssAssets.clear();
					values.forEach((ele: any) => {
						if (ssAssets.has(ele.capturedTs)) {
							const valueArray = ssAssets.get(ele.capturedTs);
							valueArray.push(ele);
						} else {
							const valueArray: any = [];
							valueArray.push(ele);
							keys.push(ele.capturedTs);
							ssAssets.set(ele.capturedTs, valueArray);
						}
					});
					setList(keys);
				} else {
					console.warn(' data view service ELSE ', screenshotDataService);
				}
			} catch (error) {
				console.error(error);
			}
		};
		getDetails();
	}, []);

	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
	};
	function a11yProps(index: number) {
		return {
			id: `scrollable-auto-tab-${index}`,
			'aria-controls': `scrollable-auto-tabpanel-${index}`,
		};
	}

	const itemTemplate = (product: any, layout: any) => {
		if (!product) {
			return;
		}
		if (layout === 'list') return renderListItem(product);
		else if (layout === 'grid') return renderGridItem(product);
	};
	const renderListItem = (data: any) => {
		if (data.assetUrl) {
			return (
				<div className="p-col-12">
					<div className="product-list-item">
						<img
							width={300}
							height={300}
							src={data.assetUrl}
							onError={(e: any) =>
								(e.target.src =
									'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png')
							}
							alt={data.deviceCode}
						/>
						{data.capturedTs && (
							<div className="product-list-detail">
								<div className="product-name">{data.deviceName} hi</div>
								<div className="product-description">
									{data.capturedTsWithTime}
								</div>
							</div>
						)}
					</div>
				</div>
			);
		}
		return <></>;
	};
	const renderGridItem = (data: any) => {
		if (data.assetUrl) {
			return (
				<div className="p-col-12 p-md-3">
					<div className="product-grid-item card">
						<div className="product-grid-item-top"></div>
						<div className="product-name">{data.mainLocationName}</div>
						<div className="product-grid-item-content">
							<img
								src={data.assetUrl}
								onError={(e: any) =>
									(e.target.src =
										'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png')
								}
								alt={data.deviceName}
							/>
							<div className="product-name">{data.deviceName}</div>
							<div className="product-description">
								{data.capturedTsWithTime}
							</div>
						</div>
					</div>
				</div>
			);
		}
		return <></>;
	};

	return (
		<div>
			<AppBar position="static" color="default">
				<Tabs
					value={value}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
					aria-label="scrollable auto tabs example">
					{list.map((ele: any, index: number) => (
						<Tab key={index} label={ele} {...a11yProps(index)} />
					))}
				</Tabs>
			</AppBar>

			{list.map((ele: any, index: number) => (
				<TabPanel key={index} value={value} index={index}>
					<BaseErrorBoundry>
						<div className="dataview-demo">
							<div className="card">
								<FormControl
									variant="outlined"
									className={classes.formControl}>
									<InputLabel htmlFor="mainLocation">
										Main Location
									</InputLabel>
									<CssSelect
										labelId="mainLocation"
										id="mainLocation"
										value={mainLocationName}
										onChange={(event:any)=>handleSelectChange(event)}
										label="Main Location">
												<MenuItem value="Select All" key="Select All">
											Select All
										</MenuItem>
										{lodash
											.uniqBy(ssAssets.get(ele), 'mainLocationName')
											.map((obj: any) => obj.mainLocationName)
											.map((mainLocationName: any) => (
												<MenuItem value={mainLocationName}>
													{mainLocationName}
												</MenuItem>
											))}
									</CssSelect>
								</FormControl>
								<DataView
									value={
										mainLocationName === '' ||
										mainLocationName === 'Select All'
											? ssAssets.get(ele)
											: ssAssets.get(ele).filter((m: any) => {
													if (
														m.mainLocationName ===
														mainLocationName
													)
														return true;
													else return false;
											  })
									}
									layout={"grid"}
									itemTemplate={itemTemplate}
									paginator
									rows={8}
								/>
							</div>
						</div>
					</BaseErrorBoundry>
				</TabPanel>
			))}
		</div>
	);
}
